// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../Config.bs.js";
import * as CrmNetwork from "../../../network/CrmNetwork.bs.js";
import * as CountryConfig from "../../country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CrmUserRepoConfig from "./CrmUserRepoConfig.bs.js";

function fetchCurrentUser(country) {
  var requestUrl = Config.Env.getHostName(undefined) + "/api/v4/orders/loggedin_admin";
  return CrmNetwork.get(requestUrl, undefined, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CrmUserRepoConfig.UserResponseConverter.execute, result);
                        });
            });
}

var T = {
  fetchCurrentUser: fetchCurrentUser
};

export {
  T ,
  
}
/* Config Not a pure module */
